<template>
  <List :mapState="'adminUsers'" :allDispatch="'adminUsersAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/admin/users/list.vue